export default __webpack_public_path__ + "static/img-channel-heading-3a405bf294ee4b67472563d81763818e.png";